import parse from "html-react-parser";
import { useCallback } from "react";
import { InlineInfoBox } from "staysure-component-library";

import QuestionDescriptionDrawer from "@/app/shared-components/question-description/drawer/drawer";
import { useWizard } from "@/app/shared-providers/wizard-context-provider";
import RichText from "@/components/atoms/rich-text/rich-text";

import OptionSelection from "./option-section";
import { UseCoverTypeSectionHook } from "../../hook/form-section.hook";
import { useCoverTypeContext } from "../../provider/cover-type.provider";

function CoverTypeFormSection() {
  const {
    magnoliaData,
    setSelectedAnswer,
    setIsInfoDrawerOpen,
    isInfoDrawerOpen,
    selectedAnswer,
  } = useCoverTypeContext();
  const { handleClick, toggleButtonOptions } =
    UseCoverTypeSectionHook(setSelectedAnswer);
  const {
    questionText,
    coverTypeSupportText,
    coverTypeInlineInfoText,
    coverTypeInfoDrawer,
  } = magnoliaData.overlayArea[0];
  const { current } = useWizard();
  const showNewButtonsLayout = current.uiElementControls?.showNewButtonsLayout;

  const handleInlineInfoInteraction = useCallback(
    (
      e: React.MouseEvent<HTMLDivElement> | React.KeyboardEvent<HTMLDivElement>
    ) => {
      if (!(e.target as HTMLElement).closest("a")) return;
      if ("key" in e && e.key !== "Enter" && e.key !== " ") return;
      e.preventDefault();
      e.stopPropagation();
      setIsInfoDrawerOpen(true);
    },
    [setIsInfoDrawerOpen]
  );

  return (
    <div
      data-testid="question-one-test-id"
      className=" lg:max-w-[414px] md:max-w-[400px] w-full mx-auto relative  flex flex-col justify-between"
    >
      <QuestionDescriptionDrawer
        drawerData={coverTypeInfoDrawer}
        isDrawerOpen={isInfoDrawerOpen}
        setIsDrawerOpen={setIsInfoDrawerOpen}
      />
      <h1
        data-testid="header-test-id"
        className={`font-header-font lg:text-[39px] md:text-3xl text-[26px] lg:leading-[45px]
      md:leading-[34px] leading-[30px] text-text-title ${
        showNewButtonsLayout
          ? "lg:text-left md:text-left text-center"
          : "md:text-left text-center"
      }`}
      >
        {questionText}
      </h1>
      <OptionSelection
        options={toggleButtonOptions}
        onOptionSelect={(id) => {
          handleClick(id);
        }}
      />
      {showNewButtonsLayout ? (
        coverTypeInlineInfoText &&
        selectedAnswer === 0 && (
          <div className="mt-spacing-l">
            <InlineInfoBox
              id="cover-type-inline-info-box"
              className="py-spacing-xs px-spacing-m max-w-[280px] mx-auto md:max-w-none md:w-full rounded-lg border !border-border-info-primary bg-surface-info-2 overflow-clip"
              content={
                <div
                  role="none"
                  className="text-3xs lg:text-2xs font-body-font leading-[21px] lg:leading-[24px] text-text-body [&_a]:font-semibold [&_a]:underline [&_a]:decoration-current [&_a]:[text-underline-position:from-font] [&_a]:[text-decoration-skip-ink:none] [&_a]:text-3xs"
                  onClick={handleInlineInfoInteraction}
                  onKeyDown={handleInlineInfoInteraction}
                >
                  {parse(coverTypeInlineInfoText)}
                </div>
              }
            />
          </div>
        )
      ) : (
        <RichText
          richText={coverTypeSupportText}
          data-testid="cover-type-support-text"
          className={`text-xs break-words font-body-font leading-[27px] text-confirmation-body
                        mt-spacing-l md:mt-spacing-s md:pb-0 pb-spacing-xs hover:no-underline md:text-left text-center`}
        />
      )}
    </div>
  );
}

export default CoverTypeFormSection;
